export default __webpack_public_path__ + "static/media/20160305-p2.5c85446f.pdf";